import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
   adminToken: string | null;
   apiUrl: string;
   cookieName: string;
   debug: boolean;
   deployTimestamp: string;
   deployUser: string;
   enabledSkaffoldProfiles: string[] | null;
   filereaderUrl: string;
   gitBranch: string;
   gitCommit: string;
   headerName: string;
   homerUrl: string;
   releaseName: string;
   extraNames: string[] | null;
   urlEnv: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
   private config: AppConfig;

   loaded = false;

   constructor(private http: HttpClient) {}

   async loadConfig(): Promise<void> {
      const data = await firstValueFrom(this.http.get<AppConfig>('assets/app.config.json'));
      this.config = data;
      this.loaded = true;
   }

   getConfig(): AppConfig {
      return this.config;
   }
}
